<template>
  <div class="lock-page">
    <div class="wrapper wrapper-full-page ">
      <div class="full-page lock-page section-image" filter-color="black">
        <!--   you can change the color of the filter page using: data-color="blue | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="lock" class="text-center">
                <img slot="header" :src="profile_image" alt="...">
                <h4 class="card-title">{{this.$store.getters.getUserFullName}}</h4>
                <fg-input type="password" 
                          placeholder="Ingrese contraseña"
                          name="contraseña"
                          autocomplete="off"
                          v-model="form.password" 
                          v-validate="modelValidations.password"
                          :error="getError('contraseña')"></fg-input>
                <p-button slot="footer" native-type="submit" @click.prevent="validate" type="warning" round outline>
                  Desbloquear
                </p-button>
              </card>
            </div>
          </div>
        </div>
        <div class="full-page-background" v-bind:style="loginBackground()"></div></div>
    </div>
  </div>
</template>
<script>
  import { Card, Button, FgInput } from 'src/components/UIComponents';
  import Loading from 'vue-loading-overlay';

  export default {
    components: {
      Card,
      Loading,
      FgInput,
      [Button.name]: Button
    },
    data(){
      return{
        profile_image : process.env.VUE_APP_BASE_ROUTE+'img/user@2x.png',
        form: {
          email: '',
          password: ''
        },
        modelValidations: {
          email: {
              email: true,
              required: true,
              max: 64
          },
          password: {
              required: true,
              max: 32
          },
        },
      }
    },
    methods: {
      loginBackground(){
        return 'background-image: url('+process.env.VUE_APP_BASE_ROUTE+'img/login_background.jpg)';
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      /*** 
      * Función que permite visualizar los errores en cada campo del input
      */
      getError (fieldName) {
          return this.errors.first(fieldName)
      },
      /***
      * Función para validar el formulario de edición y creación que se envía
      */
      validate () {
          this.$validator.validateAll().then(isValid => {
            if(isValid){
                alert('es válido');
            }
          })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
